import { HttpInterceptorFn } from "@angular/common/http";
import { throwError } from "rxjs";
import { environment } from "../../../environments/environment";
import { inject } from "@angular/core";
import { AuthService } from "../services/auth.service";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authToken = inject(AuthService).getAuthorizationToken();
  if (authToken) {
    req = req.clone({
      headers: req.headers.set('authorization',authToken.authorization )
    });
  }
  return next(req);
};
 